import React from 'react';

import { Container, Toast, ToastText } from './styles';

interface ToastContainerProps {
  show: boolean;
  message: string | null;
}

const ToastContainer: React.FC<ToastContainerProps> = ({ message, show }) => {
  return (
    <>
      {show && (
        <Container>
          <Toast>
            <ToastText>{message}</ToastText>
          </Toast>
        </Container>
      )}
    </>
  );
};

export default ToastContainer;
